var map = {
	"./TaskActionView": [
		7759,
		759
	],
	"./TaskActionView.jsx": [
		7759,
		759
	],
	"./TaskAugmentedRealityView": [
		8297,
		297
	],
	"./TaskAugmentedRealityView.jsx": [
		8297,
		297
	],
	"./TaskCheckInView": [
		6009,
		9
	],
	"./TaskCheckInView.jsx": [
		6009,
		9
	],
	"./TaskInformationView": [
		8700,
		700
	],
	"./TaskInformationView.jsx": [
		8700,
		700
	],
	"./TaskMultipleChoiceView": [
		1361,
		361
	],
	"./TaskMultipleChoiceView.jsx": [
		1361,
		361
	],
	"./TaskPhotoView": [
		1991,
		991
	],
	"./TaskPhotoView.jsx": [
		1991,
		991
	],
	"./TaskPollingView": [
		7337,
		886
	],
	"./TaskPollingView.jsx": [
		7337,
		886
	],
	"./TaskScanQRView": [
		3794,
		794
	],
	"./TaskScanQRView.jsx": [
		3794,
		794
	],
	"./TaskShortAnswerView": [
		8393,
		393
	],
	"./TaskShortAnswerView.jsx": [
		8393,
		393
	],
	"./TaskSpotTheDifferenceView": [
		9434,
		434
	],
	"./TaskSpotTheDifferenceView.jsx": [
		9434,
		434
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 5569;
module.exports = webpackAsyncContext;